export default __webpack_public_path__ + "static/internet-explorer-gravestone-overlay-9eb6dd3187a1ad7cf61c865333595e2b.png";